import React from 'react';
import styles from './Menu.m.sass';

import cx from 'classnames';

import {Link} from 'react-router';
import Collapsible from '../collapsible/Collapsible.js';

function MenuItem({name, slug, active}) {
  return (
    <div className={cx(styles.menuItem, active && styles.menuItemActive)}>
      <Link to={`/${slug}`}>
        <span className={styles.menuTitle}>{name}</span>
      </Link>
    </div>
  );
}

export default class Menu extends React.PureComponent {
  static defaultProps = {
    breadcrumbs: []
  };

  constructor(props) {
    super(props);

    this.state = {openedItem: null};

    const {breadcrumbs, items} = this.props;
    if (breadcrumbs && items) {
      const opened = items.find(item => !!breadcrumbs.find(breadcrumb => item.id === breadcrumb.id));
      this.state = {openedItem: opened && opened.id};
    }
  }

  componentDidUpdate(prevProps) {
    const {breadcrumbs, items} = this.props;

    if (breadcrumbs && items && prevProps.breadcrumbs !== breadcrumbs) {
      const opened = items.find(item => !!breadcrumbs.find(breadcrumb => item.id === breadcrumb.id));
      if (opened) {
        this.setState({openedItem: opened && opened.id});
      }
    }
  }

  handleCollapsibleClick = idx => this.setState(prevState => ({
    openedItem: prevState.openedItem === idx ? null : idx
  }));

  isActive = (taxon) => !!this.props.breadcrumbs.find(it => it.code === taxon.code);

  render() {
    const {items, mobile} = this.props;
    const {openedItem} = this.state;

    return (
      <aside className={cx(styles.menu, mobile && styles.menuMobile)}>
        <div className={styles.menuContent}>
          {items.map(item => item.children && item.children.length ? (
            <Collapsible
              key={item.id}
              trigger={
                <Link to={`/${item.slug}`} onClick={e => e.stopPropagation()}>
                  <span className={styles.menuTitle}>{item.name}</span>
                </Link>
              }
              open={item.id === openedItem}
              duration={400}
              onTriggerClick={() => this.handleCollapsibleClick(item.id)}
              className={`${styles.menuItem} ${styles.menuItemHasChildren}`}
              openedClassName={`${styles.menuItem}  ${styles.menuItemHasChildren}  ${styles.menuItemOpened}`}
              triggerClassName={cx(styles.menuTrigger, this.isActive(item) && styles.menuTrigger)}
              contentOuterClassName={styles.menuList}
            >
              {item.children.map(child => <MenuItem key={child.id} active={this.isActive(child)} {...child}/>)}
            </Collapsible>
          ) : (
            <MenuItem key={item.id} active={this.isActive(item)} {...item}/>
          ))}
        </div>
      </aside>
    );
  }
}



// WEBPACK FOOTER //
// ./components/menu/Menu.js